import { useQuery } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { APIInstance } from '@/utils/functions/instance'
import { IGetCorrectionsResponseType } from './type'
import { IResponseType } from '@/types/response-type'

export function useGetCorrections({
  data,
  disableToast,
  ...rest
}: IApiBaseTypes<{}>) {
  return useQuery({
    queryFn: async () =>
      await APIInstance<IGetCorrectionsResponseType>({
        url: 'mrf/status/',
        params: data,
        method: 'get',
        data
      }),
    retry: 0,
    queryKey: ['correctionItem', data],
    select: (data) => data?.data,
    ...rest
  })
}
